import { gql } from '@grandvisionhq/graphql';
import { openCloseTimePair } from './opening-hours.js';

const pickupPoint = gql`
  fragment PickupPoint on PickupPoint {
    globalPickupPointId
    lat
    lon
    name
    distance
    postalCode
    town
    streetName
    streetNumber
    additionalStreetInfo
    country
    monOpenClose {
      ...OpenCloseTimePair
    }
    tueOpenClose {
      ...OpenCloseTimePair
    }
    wedOpenClose {
      ...OpenCloseTimePair
    }
    thuOpenClose {
      ...OpenCloseTimePair
    }
    friOpenClose {
      ...OpenCloseTimePair
    }
    satOpenClose {
      ...OpenCloseTimePair
    }
    sunOpenClose {
      ...OpenCloseTimePair
    }
  }
  ${openCloseTimePair}
`;

export { pickupPoint };
//# sourceMappingURL=pickup-point.js.map
